import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { LOAD_CHAT_WINDOW } from './shared/constants';

export function loadAdaChat(token, user: Partial<IUser>) {
  loadAdaEmbedJS().then(() => {
    startAdaChatWIthConfig(token, user);
  });
}

function loadAdaEmbedJS() {
  const el = document.createElement('script');
  el.id = '__ada';
  el.type = 'text/javascript';
  el.async = true;
  el.src = 'https://static.ada.support/embed2.js';
  el.dataset.handle = ADA_CHAT_HANDLE;
  el.dataset.lazy = '';
  document.body.appendChild(el);

  return new Promise((res, rej) => {
    el.onload = res;
    el.onerror = rej;
  });
}

function startAdaChatWIthConfig(token, user: Partial<IUser>) {
  const adaEmbedObj = (window as any).adaEmbed;
  adaEmbedObj.start({
    handle: ADA_CHAT_HANDLE,
    metaFields: {
      metaEmail: user.email,
      metaName: user.name,
      metaAuthToken: token,
    },
    crossWindowPersistence: {
      enabled: true,
    },
    adaReadyCallback: () => {
      adaEmbedObj.toggle();
    },
  });
}

export function onVerificationPage() {
  const searchParams = new URLSearchParams(window.location.search);
  return !!searchParams.has(LOAD_CHAT_WINDOW);
}
